import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

import {Directive} from '@angular/core';

@Directive({
    selector: '[appWorkingDay]',
    providers: [{provide: NG_VALIDATORS, useExisting: WorkingDayDirective, multi: true}]
})
export class WorkingDayDirective implements Validator {

    constructor() {
    }

    validate(control: AbstractControl): ValidationErrors | null {
        // console.log('.....' + control.value, control);
        // console.log('=> validated as', this.validateDate(control));
        // console.log('value', control.value);
        return this.validateDate(control);
    }

    private validateDate(control: any) {

        if (!control || !control.value) {
            return null;
        }

        // if (control.errors && !(control.errors.hasOwnProperty('isNotWorkingDate'))) {
        //     // do not validate if another errors exists
        //     return null;
        // }
        // console.log('control.errors ', control.errors );


        // const dayToCheck = new Date(control.value).getDay();
        const dayToCheck = control.value.getDay();

        if (dayToCheck === 0 || dayToCheck === 6) {
            return {isNotWorkingDate: true};
        }

        return null;

    }
}
